import { render, staticRenderFns } from "./auto-modal.vue?vue&type=template&id=3e195d06&scoped=true"
import script from "./auto-modal.ts?vue&type=script&lang=ts&external"
export * from "./auto-modal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e195d06",
  null
  
)

export default component.exports